import xhr from '@/util/xhr'
import browser from '@/util/browser'

const wxjssdk = {
  init() {
    if (browser.wechatBrowser) {
      xhr.get(`/rest/nezha-api/api/v1/wechat/getConfigSign?url=${encodeURIComponent(location.href)}`).then((res) => {
        if (res.code === 200) {
          // 微信jssdk设置
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: 'wx4798aede6dc4ffb6', // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: [
              'updateAppMessageShareData',
              'updateTimelineShareData'
            ] // 必填，需要使用的JS接口列表
          })
        }
      })
    }
  },
  updateShareData(shareData) {
    if (browser.wechatBrowser) {
      wx.ready(function() {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        wx.updateAppMessageShareData({
          title: shareData.title, // 分享标题
          desc: shareData.desc, // 分享描述
          link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareData.imgUrl, // 分享图标
          success: function () {
            // 设置成功
          }
        })

        wx.updateTimelineShareData({
          title: shareData.title, // 分享标题
          link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareData.imgUrl, // 分享图标
          success: function () {
            // 设置成功
          }
        })
      })
    }
  }
}

export default wxjssdk
